<script setup lang="ts">
const { state, errorMessage, mobileNumber, trackingId } = defineProps<{
    state: 'succeed' | 'failed';
    errorMessage?: string;
    mobileNumber: string;
    trackingId?: string;
}>();

const emit = defineEmits<{
    close: [];
}>();

const router = useRouter();

const isSucceed = computed(() => state === 'succeed');

const title = computed(() =>
    isSucceed.value ? 'لینک با موفقیت ارسال شد' : 'ارسال لینک انجام نشد'
);

const content = computed(() =>
    isSucceed.value
        ? `پیامک حاوی لینک پرداخت به شماره موبایل ${mobileNumber} با موفقیت ارسال شد. در صورتی که پرداخت موفق باشد، شما می‌توانید برای اطلاع از وضعیت صدور بلیط خود به بخش «پیگیری خرید» مراجعه کنید.`
        : errorMessage || 'در فرآیند رزرو پرواز مشکلی پیش آمد.'
);

const navigateToReserves = () =>
    router.push(
        `/after-order/payment-waiting?trackingId=${trackingId}&mobile=${mobileNumber}`
    );
</script>

<template>
    <mr-modal :title width="min(100vw - 32px, 440px)" @close="emit('close')">
        <div class="payment-link-content">
            <mr-typography align="center" weight="500" color="black">
                {{ content }}
            </mr-typography>
            <mr-flash-message
                v-if="state === 'succeed'"
                message="در نظر داشته باشید که لینک ارسال شده تنها 15 دقیقه اعتبار دارد و پس از آن منقضی شده و برای خرید بلیط باید مجدد اقدام کنید."
            />
        </div>
        <template #footer>
            <div v-if="isSucceed" class="actions">
                <mr-button variant="bordered" full-width @click="emit('close')">
                    بستن
                </mr-button>
                <mr-button full-width @click="navigateToReserves">
                    پیگیری خرید
                </mr-button>
            </div>
            <mr-button v-else full-width @click="emit('close')">
                متوجه شدم
            </mr-button>
        </template>
    </mr-modal>
</template>

<style scoped lang="scss">
.payment-link-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.actions {
    display: flex;
    align-items: center;
    gap: 12px;
}
</style>
